import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-dataV-digitalFlop",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {
      uuid: null,
      flopConfig: {}
    };
  },
  watch: {
    'option.attribute': {
      handler: function handler() {
        this.loadData();
      },
      deep: true //深度监听

    },
    width: function width() {
      this.loadData();
    }
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "DigitalFlop").then(function (res) {
        _this.flopConfig = {
          number: res.value.split(',').map(Number),
          content: _this.option.attribute.content,
          toFixed: _this.option.attribute.toFixedNum,
          textAlign: _this.option.attribute.textAlign,
          rowGap: _this.option.attribute.rowGap,
          style: _this.option.attribute.style
        };
      });
    }
  }
};